import { View } from 'react-native'
import { SignatureCanvas } from './SignatureCanvas'
import CanvasSettings from './CanvasSettings'
import { SignatureCanvasRef } from './SignatureCanvas.types'
import { useRef } from 'react'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import PressableIcon from '@ui/buttons/PressableIcon'
import { colors } from '@ui/colors'
import { useTranslation } from 'react-i18next'

type SignatureProps = {
  onSave?: (image: string) => void
  buttonProps?: Partial<Omit<ButtonProps, 'onPress'>>
  disabled?: boolean
}

const Signature = ({ onSave, buttonProps, disabled }: SignatureProps) => {
  const canvasRef = useRef<SignatureCanvasRef>(null)

  const { t } = useTranslation(['ui'])

  const handleSave = () => {
    const image = canvasRef.current?.getImage()
    if (!image) {
      console.error('No image found')
      return
    }
    onSave?.(image)
  }

  const handleClear = () => {
    canvasRef.current?.clear()
  }

  return (
    <>
      <View
        style={{
          width: CanvasSettings.dimensions.width + CanvasSettings.padding * 2,
          height: CanvasSettings.dimensions.height + CanvasSettings.padding * 2,
          padding: CanvasSettings.padding,
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
        className="relative items-center justify-center rounded-xl border border-black/10 bg-white"
      >
        <SignatureCanvas ref={canvasRef} />
        <View className="absolute bottom-2 right-2">
          <PressableIcon
            color={colors.gray[300]}
            name="trash"
            onPress={handleClear}
          />
        </View>
      </View>

      <Button
        onPress={handleSave}
        label={t('ui:save')}
        variant="outlined"
        {...buttonProps}
      />
    </>
  )
}

export default Signature
